module.exports = {"350921001":"松城街道","350921002":"松港街道","350921003":"松山街道","350921101":"长春镇","350921102":"牙城镇","350921103":"溪南镇","350921104":"沙江镇","350921105":"下浒镇","350921106":"三沙镇","350921200":"盐田畲族乡","350921201":"水门畲族乡","350921202":"崇儒畲族乡","350921203":"柏洋乡","350921204":"北壁乡","350921205":"海岛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350921.json
// module id = 1350
// module chunks = 0